import { defineMessages } from "react-intl";

export const messages = defineMessages({
  alertText: {
    id: "alert.info.changePassword.text",
    defaultMessage: "Please update your password to maintain account security.",
    description: "Alert text to recommend user to update password",
  },
  alertButtonLabel: {
    id: "alert.info.changePassword.button.label",
    defaultMessage: "Update password",
    description: "Alert button label",
  },
});
